import { UserState } from '../../types/user/user.def';
import { ExtendAction } from '../types';
import { Notification } from '../../types/notifications/notification.def';
import { AvatarUrl } from '../../types/avatar/avatarList.def';

type SetUserAction = { type: string; payload: UserState };

type SetUserNotificationsAction = ExtendAction<
  Notification['id'],
  typeof SET_USER_NOTIFICATION
>;

export type UserActions = SetUserNotificationsAction | SetUserAction;

export const SET_USER = 'SET_USER';
export const SET_USER_NOTIFICATION = 'SET_USER_NOTIFICATION';
export const UPDATE_AVATAR = 'UPDATE_AVATAR';
export const UPDATE_USER = 'UPDATE_USER';

export const setUser = (payload: UserState): SetUserAction => ({
  type: SET_USER,
  payload
});

export const setUserNotifications = (payload): SetUserNotificationsAction => ({
  type: SET_USER_NOTIFICATION,
  payload
});

export const updateAvatar = (payload: AvatarUrl) => ({
  type: UPDATE_AVATAR,
  payload
});

export const updateUser = (payload: UserState) => ({
  type: UPDATE_USER,
  payload
});
